<template>
  <div class="home">
    <Header />
    <div class="row">
      <div class="col1 con">
        <L1 />
      </div>
      <div class="col2">
        <div class="con" style="height:356px">
          <R1 />
        </div>
        <div class="con" style="margin-top:15px;height:170px">
          <R2 />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from './header'
import L1 from './L1.vue'
import R1 from './R1.vue'
import R2 from './R2.vue'

export default {
  name: 'Home',
  components: {
    Header,
    L1,
    R1,
    R2,
  },
  
}
</script>

<style lang="less" scoped>
.home {
  width: 100%;
  .row {
    width: 1200px;margin: 15px auto;display: flex;justify-content: space-between;
    .col1 {
      width: 798px;
      height: 541px;
       
    }
    .col2 {
      width: 387px;
    }
    .con {
      background-color: #fff;
      border: 1px solid #dfdfdf;
      box-sizing: border-box;
      padding: 10px 10px;
      overflow: hidden;
    }
  }
}
</style>